class RestoreWalletTemplateWorkflow {
    constructor($injector) {
        this.injector = $injector;
        this.state = this.injector.get('$state');
        this.http = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');

        this.key = 'restore-passbook';
        this.title = this.translate.instant('general.verbs.restore');
        this.level = 'archived-highlight';
        this.icon = 'undo';
    }

    action(template, vm) {
        this.http
            .put(`wallets/templates/${template.id}/restore`)
            .then(() => this.state.go('app.wallets.templates.details', {id: template.id}, {reload: true}))
            .catch(err => this.alert.handle(err));
    }
}

angular
    .module('festzelt-os.modules.wallets.templates')
    .factory('restorePassbook', [
        '$injector',
        ($injector) => new RestoreWalletTemplateWorkflow($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/workflows/details/restore.js